<app-seamless-header></app-seamless-header>

<section class="extra_padding_for_header">
<div class="progress-bar-custom">
    <div class="progress-bar-custom__fill"></div>
</div>

<div class="ready-text-holder">
    <div class="d-flex justify-content-center align-items-center mb-3">
        <img src="../../assets/images/check-circle.png" width="56px" alt="Check Circle" class="">
    </div>
        <div class="d-flex flex-column welcome-text text-center">
        <div>
            <div class="fw-bold">You're all set,</div>
            <div class="fw-bold">{{username}}!</div>
        </div>
        <div class="align-self-center blue_line"></div>
        <div class="snapshot">Time to start making<div class="credit_health"> good money choices!</div>
        </div>
    </div>
</div>
</section>